import React, { PropTypes, Component } from 'react'
import styles from '../styles'
import AutoComplete from 'components/autocomplete'
import CellDiv from './cellDiv'
import misc from 'utils/misc'

export default class AutoCompleteCell extends Component {
  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    map: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
    dropDown: PropTypes.bool,
  };

  constructor (props) {
    super(props)
    this.onSelect = (item, i) => {
      const keys = Object.keys(this.props.map)
      this.props.onSelect(props.dataKey, keys[i])
    }
  }

  shouldComponentUpdate (nextProps) {
    // you need to avoid update by passing same items object to it
    const compareKeys = ['value', 'map', 'width']
    return !misc.isObjectEqual(this.props, nextProps, compareKeys)
  }

  render () {
    const { value, map, dropDown, width } = this.props

    const items = misc.objectValues(map)

    return (
      <CellDiv width={width} className={styles.autoCompleteCell}>
        <AutoComplete {...{ value, onSelect: this.onSelect, items, dropDown }} expand />
      </CellDiv>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataTable/dataCell/autoCompleteCell.jsx